export default __webpack_public_path__ + "static/admin-6e897ad652eab235901a7519a7917ade.webp";